import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { faLongArrowRight, faExclamationCircle, faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    mail: string;
    pass: string;
    error: string;
    passType: string = "password";
    validMail: boolean = null;
    validPass: boolean = null;

    // checker if ios
    iOS: boolean;

    // checker if returnUrl
    returnUrl: any = null;

    constructor(public auth: AuthService, private router: Router, private route: ActivatedRoute) {
        this.iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
    }

    ngOnInit() {
        this.auth.user$.subscribe(user => {
            if(user) {
                this.router.navigate(['/dashboard']);
            }
        })
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
    }

    async login(e) {
        e.preventDefault();
        if(this.validMail && this.validPass) {
            let e = await this.auth.signin(this.mail, this.pass, this.returnUrl);
            // if error
            if(e) {
                switch (e.code) {
                    case "auth/user-not-found":
                        return this.error = "Es gibt keinen Benutzer mit dieser E-Mail";
                    case "auth/invalid-email":
                        return this.error = "Bitte geben Sie eine valide E-Mail Adresse ein.";
                    case "auth/user-disabled":
                        return this.error = "Der Benutzer wurde deaktiviert.";
                    case "auth/wrong-password":
                        return this.error = "Inkorrektes Passwort.";
                    default:
                        return this.error = "Leider ist beim Anmelden ein Fehler aufgetreten. Kontaktieren Sie einen Support";
                }
            } else {
                this.error = null;
            }
        } else {
            if(this.validPass) {
                this.validateMail();
            } else {
                this.validatePass();
            }
        }
    }

  validateMail() {
    if(this.mail != null) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.mail)) {
        this.error = null;
        return this.validMail = true;
      } else {
        this.error = 'Bitte geben Sie eine valide E-Mail Adresse ein.';
        return this.validMail = false;
      }
    } else {
      this.error = 'Bitte füllen Sie alle Felder aus.'
      return this.validMail = false;
    }
  }

  validatePass() {
    if(this.pass != null) {
      if (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(this.pass)) {
        this.error = null;
        return this.validPass = true;
      } else {
        this.error = 'Bitte geben Sie eine Passwort mit min. 8 Zeichen ein, welches sowohl Groß-, Kleinbuchstaben und Ziffern besitzt.';
        return this.validPass = false;
      }
    } else {
      this.error = 'Bitte füllen Sie alle Felder aus.'
      return this.validPass = false;
    }
  }

  toggleVisability() {
    if(this.passType == "password") {
      this.passType = "text";
    } else {
      this.passType = "password";
    }
  }

  longArrowRight = faLongArrowRight;
  exclamationCircle = faExclamationCircle;
  eye = faEye;
  eyeSlash = faEyeSlash;

}
